export { Rewards as default } from '@/src/experiences/rewards/screens/Rewards'
